/// <amd-module name="Test/TestPlansHubRefresh/TestPlanClonePanel/Redux/TestPlanClonePanelActions" />

import { ActionsUnion, createAction } from "redux/Utils/ActionHelper";
import { INode } from "./TestPlanClonePanelContracts";

export const TestPlanClonePanelActions = {
    /**
     * getRootNodes: fetch area path and iteration details
     */
    getRootNodes: () => createAction(TestPlanClonePanelActionsTypes.getRootNodes),

    /**
     * loadModules: load dependent modules
     */
    loadModules: () => createAction(TestPlanClonePanelActionsTypes.loadModules),

    /**
     * mandatoryFieldUpdated: this action is dispatched to update the flag for evaluating if all mandatory fields are updated.
     */
    mandatoryFieldUpdated: (isMandatoryFieldUpdated: boolean) =>
        createAction(TestPlanClonePanelActionsTypes.mandatoryFieldUpdated, isMandatoryFieldUpdated),

    /**
     * loadModules: this action is dispatched to notify that all dependent modules are loaded
     */
    loadModulesSucceeded: () => createAction(TestPlanClonePanelActionsTypes.loadModulesSucceeded),

    /**
     * getRootNodesSucceeded: this action is dispatched when area path and itration details nodes are fetched from API
     */
    getRootNodesSucceeded: (areaPathNode: INode, iterationNode: INode) =>
        createAction(TestPlanClonePanelActionsTypes.getRootNodesSucceeded, { areaPathNode, iterationNode }),

    /**
     * copyTestPlan: copy the test plan
     */
    copyTestPlan: (oldPlanId: number, newPlanName: string, areatPath: string, iteration: string, isDeepClone: boolean) =>
        createAction(TestPlanClonePanelActionsTypes.copyTestPlan, { oldPlanId, newPlanName, areatPath, iteration, isDeepClone }),

    /**
     * copyTestPlanSucceded: invoke the reducer to get the new test plan Id and op Id
     */
    copyTestPlanSucceded: (newPlanId: number, opId: number) => createAction(TestPlanClonePanelActionsTypes.copyTestPlanSucceded, { newPlanId, opId }),

    /**
     * copyTestPlanFailed: invoke the reducer to change the clone in progress status to false
     */
    copyTestPlanFailed: () => createAction(TestPlanClonePanelActionsTypes.copyTestPlanFailed),

    /**
     * copyTestPlanInProgress: invoke the reducer to show copying is in progress
     */
    copyTestPlanInProgress: () => createAction(TestPlanClonePanelActionsTypes.copyTestPlanInProgress)
};

export const enum TestPlanClonePanelActionsTypes {
    getRootNodes = "TestPlanClonePanel/getRootNodes",
    loadModules = "TestPlanClonePanel/loadModules",
    loadModulesSucceeded = "TestPlanClonePanel/loadModulesSucceeded",
    getRootNodesSucceeded = "TestPlanClonePanel/getRootNodesSucceeded",
    copyTestPlan = "TestPlanClonePanel/copyTestPlan",
    copyTestPlanInProgress = "TestPlanClonePanel/copyTestPlanInProgress",
    copyTestPlanSucceded = "TestPlanClonePanel/copyTestPlanSucceded",
    copyTestPlanFailed = "TestPlanClonePanel/copyTestPlanFailed",
    mandatoryFieldUpdated = "TestPlanClonePanel/mandatoryFieldUpdated"
}

export type TestPlanClonePanelActions = ActionsUnion<typeof TestPlanClonePanelActions>;
